import { lazy } from "react";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import { Navigate } from "react-router-dom";

const TripRequestList = lazy(() => import("../components/tripRequestList"));
const TripRequestView = lazy(() => import("../components/tripRequestView"));

const tripRequestRoute = {
  icon: DirectionsCarIcon,
  name: "Trip Management",
  link: "/trip-management",
  path: "trip-management",
  index: 8,
  element: "",
  superAdminView: false,
  children: [
    {
      path: "trip-request",
      element: <TripRequestList />,
      permission: "Trip Requests-Read",
      name: "Trip Requests",
      index: 2,
      link: "trip-management/trip-request",
      icon: BadgeOutlinedIcon,
    },
    {
      path: "trip-request/view/:id",
      element: <TripRequestView />,
    },
    {
      path: "",
      element: <Navigate to="trip-request" replace />,
    },
  ],
};
export default tripRequestRoute;
